import * as actions from "Actions";
import * as api from "Api";
import { pushSourceToken } from "Utils";

export const fetchPellets = ({ limit, clientId = null }) => {
  return (dispatch, getState) => {
    let sourceToken = pushSourceToken("FETCH_PELLETS", dispatch);

    const { auth } = getState();
    const { token, navCommunity, user, loggedAs } = auth;

    let currentId = null;

    if (clientId) {
      currentId = clientId;
    }

    if (loggedAs === "CLIENT") {
      if (!user || !user.role || !user.role.organization) {
        return null;
      }
      currentId = user.role.organization.id;
    }

    return dispatch(
      actions.fetchPellets(
        api.getPellets({
          token,
          limit,
          communityId: navCommunity ? navCommunity.id : null,
          sourceToken,
          currentId
        })
      )
    );
  };
};

export const fetchInfinitePellets = ({
  limit = 20,
  offset = 0,
  clientId = null
}) => {
  return (dispatch, getState) => {
    const { auth } = getState();
    const { token, navCommunity, user, loggedAs } = auth;

    let currentId = null;

    if (clientId) {
      currentId = clientId;
    }

    if (loggedAs === "CLIENT") {
      if (!user || !user.role || !user.role.organization) {
        return null;
      }
      currentId = user.role.organization.id;
    }

    return dispatch(
      actions.fetchInfinitePellets(
        api.getPellets({
          token,
          limit,
          offset,
          communityId: navCommunity ? navCommunity.id : null,
          currentId
        })
      )
    );
  };
};



// WEBPACK FOOTER //
// ./src/actions/thunks/pellet.js